import { SkillKind } from "~/shared/enums";

// Duplicate with core/setup/populate.py, keep in sync
export const PLAN_STANDARD_PROMPT = `
Update all of the tasks in this dartboard to make them into an executable project plan that runs from today to 30 days from today.

Instructions

1. Assign or re-assign each task to the teammate best suited for it
2. Pick realistic start and due dates inside the project window
3. Dates must not overlap for the same assignee but should overlap across different assignees to maximize parallel work
4. Keep existing priority and size values unless you see a clear mismatch with the details of the task
5. Make the updates directly to the tasks reflects the new dates, assignees, etc. that you decide

When you're finished, just confirm and summarize the changes with links. If anything is unclear, ask a clarifying question—but aim to work without needing one.
`.trim();

export const BRAINSTORM_STANDARD_PROMPT = `
Brainstorm and create new tasks that complement the existing tasks in this dartboard. If there are no tasks create some based only on the dartboard title if it's clear enough. Generate and save the tasks in this dartboard, don't just suggest them.

Make the tasks using titles only, with no leading numbers or punctuation. If anything is unclear, ask a clarifying question—but aim to work without needing one.
`.trim();

export const STANDUP_STANDARD_PROMPT = `
Generate a standup report, grouping tasks by assignee in alphabetical order, skip unassigned tasks and save it.
`.trim();

export const CHANGELOG_STANDARD_PROMPT = `
Summarize tasks completed during last week into a changelog. Use the completed at date to determine when tasks were finished.
Highlight the most important task(s) first, then list the rest and save the changelog.
`.trim();

export const BREAK_INTO_SUBTASKS_STANDARD_PROMPT = `
Break this task into clear, concrete subtasks and create them.

Instructions

1. Create 3-5 subtasks as child tasks of that task
2. Keep each subtask title action-oriented and specific
3. Prefer preserving any useful existing subtasks; avoid duplicates
`.trim();

export const DEFAULT_SKILL_PROMPT_BY_KIND: Partial<Record<SkillKind, string>> = {
  [SkillKind.BRAINSTORM_NEW_TASKS]: BRAINSTORM_STANDARD_PROMPT,
  [SkillKind.PLAN_PROJECT]: PLAN_STANDARD_PROMPT,
  [SkillKind.STANDUP_REPORT]: STANDUP_STANDARD_PROMPT,
  [SkillKind.WRITE_CHANGELOG]: CHANGELOG_STANDARD_PROMPT,
  [SkillKind.BREAK_INTO_SUBTASKS]: BREAK_INTO_SUBTASKS_STANDARD_PROMPT,
};
